// @greenlight-spec: 19-design-system.md
// @greenlight-spec: 28-it-dashboard-ui.md

import * as React from 'react';

import { Eyebrow } from '@/components/greenlight/Eyebrow';
import { InstallStepGroupsContext, stepPosition } from '@/components/install/stepGroups';
import type { InstallStep } from '@greenlight/shared';

interface StepHeaderProps {
  /** Any server step in this screen's group — the position derives from the group. */
  step: InstallStep;
  title: string;
  children?: React.ReactNode;
}

/** Every wizard screen's heading block: eyebrow, the screen's single h1, and lede. */
export function StepHeader({ step, title, children }: StepHeaderProps) {
  const { index, count } = stepPosition(step, React.useContext(InstallStepGroupsContext));
  return (
    <div>
      <Eyebrow>
        Step {index} of {count}
      </Eyebrow>
      <h1 className="text-2xl md:text-[28px] font-semibold tracking-[-0.02em] text-foreground">
        {title}
      </h1>
      {children && <p className="text-sm text-muted-foreground mt-2">{children}</p>}
    </div>
  );
}
